import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Checkbox
} from "@mui/material";

const Holidays = () => {
  const baseURL = process.env.REACT_APP_API_URL;

  const [holidays, setHolidays] = useState([]);
  const [form, setForm] = useState({
    title: "",
    date: "",
    start_date: "",
    end_date: "",
    is_optional: false,
    description: ""
  });

  // 🔹 Fetch holidays
  const fetchHolidays = async () => {
    try {
      const res = await axios.get(`${baseURL}holidays`);
      setHolidays(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchHolidays();
  }, []);

  // 🔹 Handle input
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  // 🔹 Save holiday
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${baseURL}holidays`, form);
      fetchHolidays();
      resetForm();
    } catch (err) {
      console.error(err);
      alert("Error saving holiday");
    }
  };

  // 🔹 Delete
  const deleteHoliday = async (id) => {
    await axios.delete(`${baseURL}holidays/${id}`);
    fetchHolidays();
  };

  const resetForm = () => {
    setForm({
      title: "",
      date: "",
      start_date: "",
      end_date: "",
      is_optional: false,
      description: ""
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <h2>Holiday Management</h2>

      {/* 🔥 FORM */}
      <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
        <TextField
          label="Holiday Name"
          name="title"
          value={form.title}
          onChange={handleChange}
          required
          fullWidth
          sx={{ mb: 2 }}
        />

        <TextField
          label="Single Date"
          type="date"
          name="date"
          value={form.date}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
        />

        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            label="Start Date"
            type="date"
            name="start_date"
            value={form.start_date}
            onChange={handleChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="End Date"
            type="date"
            name="end_date"
            value={form.end_date}
            onChange={handleChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <label>
            <Checkbox
              name="is_optional"
              checked={form.is_optional}
              onChange={handleChange}
            />
            Optional Holiday
          </label>
        </Box>

        <TextField
          label="Description"
          name="description"
          value={form.description}
          onChange={handleChange}
          fullWidth
          multiline
          rows={2}
          sx={{ mt: 2 }}
        />

        <Button type="submit" variant="contained" sx={{ mt: 2 }}>
          Save Holiday
        </Button>
      </form>

      {/* 📊 TABLE */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Range</TableCell>
              <TableCell>Optional</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {holidays.map((h) => (
              <TableRow key={h.id}>
                <TableCell>{h.title}</TableCell>
                <TableCell>{h.date}</TableCell>
                <TableCell>
                  {h.start_date && h.end_date
                    ? `${h.start_date} → ${h.end_date}`
                    : "-"}
                </TableCell>
                <TableCell>{h.is_optional ? "Yes" : "No"}</TableCell>
                <TableCell>{h.description}</TableCell>
                <TableCell>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => deleteHoliday(h.id)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Holidays;